import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import review from "@/middlewares/review"

const reviewRoutes: RouteRecordRaw[] = [
  {
    path: "/reviews",
    name: "review-management",
    component: () => import("@/views/reviews/ReviewsManagement.vue"),
    meta: {
      middleware: [auth, review],
      title: "reviews.page_title",
    },
  },
  {
    path: "/reviews/:externalId",
    name: "single-review",
    component: () => import("@/views/reviews/SingleReview.vue"),
    meta: {
      middleware: [auth],
      title: "reviews.page_title",
    },
  },
]

export default reviewRoutes
